// Shared by sign-up and settings.
export const OCCUPATIONS = [
  ["", "Select your focus"],
  ["Student", "Student"],
  ["Web Designer", "Web Designer"],
  ["Frontend Developer", "Frontend Developer"],
  ["Backend Developer", "Backend Developer"],
  ["others", "Other"],
];

// The profession to save: the free-text one when "Other" is picked.
export const professionOf = (form) => (form.profession === "others" ? form.otherProfession.trim() : form.profession);

// Validator errors arrive as [{ field, message }]; anything else is one
// form-level message (`fallback` when there is none).
export function splitErrors(message, fallback) {
  if (Array.isArray(message)) return message.reduce((acc, e) => ({ ...acc, [e.field]: e.message }), {});
  return { form: typeof message === "string" ? message : fallback };
}
